import { getField, updateField } from "vuex-map-fields";
import db from "@/firebase/firebaseInit";
const state = {
    highDemands: [],
    donationCenters: [],
    donationCenterId: "",
    donationCenterItems: [],
    currentMapLocation: null
};

const actions = {
    async fetchAllDonationCenters({ commit }) {
        await db.collection('/donation_centers/et/centers').get().then(
            (snapshot) => {
                var donationCenters = [];
                snapshot.forEach(doc => {
                    donationCenters.push({
                        id: doc.id,
                        content: doc.data()
                    })
                });
                commit("updateField", {
                    path: "donationCenters",
                    value: donationCenters,
                })
            });
    },
    async fetchHighDemandItems({ commit }, { payload }) {
        await db.collection(`/donation_inventory/${payload.centerId}/high_demands`).get().then(
            (snapshot) => {
                var highDemands = [];
                snapshot.forEach(doc => {
                    highDemands.push({
                        id: doc.id,
                        content: doc.data()
                    })
                });
                commit("updateField", {
                    path: "highDemands",
                    value: highDemands,
                })
            });
    },

    async addDonationCenter({ }, { payload }) {
      
        await db.collection('/donation_centers/et/centers').add({
            name: payload.center.name,
            address: payload.center.address,
            city: payload.center.city,
            country: payload.center.country,
            location: payload.center.location,
            phoneNumber: payload.center.phoneNumber,
        });

    },

    currentDonationCenterLocation({ commit }, { payload }) {
      
        var currentMapLocation = {
            lat: payload.lat,
            long: payload.long
        }

        commit("updateField", {
            path: "currentMapLocation",
            value: currentMapLocation,
        })
    },
    selectedDonationCenterId({ commit }, { payload }) {
        commit("updateField", {
            path: "donationCenterId",
            value: payload.centerId,
        })
    },
    async selectedDonationCenterItems({ commit }, { payload }) {

        await db.collection(`/donation_inventory/${payload.centerId}/donations`).get().then(
            (snapshot) => {
                var donationCenterItems = [];
                snapshot.forEach(doc => {
                    donationCenterItems.push({
                        id: doc.id,
                        content: doc.data()
                    })
                });
                commit("updateField", {
                    path: "donationCenterItems",
                    value: donationCenterItems,
                })
            });
    },

    async addDonationInventoryItem({ }, { payload }) {
        
        await db.collection(`/donation_inventory/${payload.centerId}/donations`).add({
            address: payload.inventory.address,
            date: payload.inventory.date,
            description: payload.inventory.description,
            fullName: payload.inventory.fullName,
            location: payload.inventory.location,
            phoneNumber: payload.inventory.phoneNumber,
            userId: payload.inventory.userId,
        })
    },

    async addHighDemandItem({ }, { payload }) {
       
        await db.collection(`/donation_inventory/${payload.centerId}/high_demands`).add({
            name: payload.demand.name,
            caption: payload.demand.caption,
            demandRate: payload.demand.demandRate,
            timestamp: payload.demand.timestamp,
            image: payload.demand.imagePath
        })
    }
};

const mutations = {
    updateField,
};

const getters = {
    getField,
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
